import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useScheduleContext } from "../context/useScheduleContext";
import { useGroups } from "../../../../Settings/General/OrganisationLevelGroups/context";

export const useColumns = () => {
    const { t } = useTranslation();
    const { allocatedGroups } = useGroups();
    const { columns: columnsConfig, viewBy } = useScheduleContext();

    return useMemo(() => {
        const baseColumns: any = [
            {
                field: "name",
                text: t("name"),
                disabled: true, //!!columnsConfig["name"] || viewBy === "name" || typeof viewBy === "undefined",
                className: "",
                viewOptionLabel: t("users"),
                // render: ({ value }: any) => {
                //     //    return <div>{value}</div>
                //     return value;
                // },
                // ...other options
            },
            { field: "job", text: t("job"), disabled: !!viewBy && viewBy !== "name" },
            { field: "location", text: t("location"), disabled: !!viewBy && viewBy !== "name" }
        ];

        if (allocatedGroups?.length > 0) {
            allocatedGroups.forEach((group: any) => baseColumns.push({
                field: group.level.replaceAll("_", ""),
                text: group.description,
                disabled: !!viewBy && viewBy !== "name"
            }));
        }

        const mergedColumns = baseColumns.map((col: any) => {
            const isVisible = typeof columnsConfig?.[col.field] === "boolean"
                ? columnsConfig[col.field]
                : col.field === "name";
            return {
                ...col,
                hide: !isVisible,
            };
        });

        return mergedColumns;
    }, [allocatedGroups, columnsConfig, viewBy, t]);
}
